import { Fragment, useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Avatar,
  Typography,
  Grid,
  Chip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../redux/slices/memberSlice";
import { RiDeleteBin6Line } from "react-icons/ri";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "#fff",
    [theme.breakpoints.up("sm")]: { width: "85%" },
    [theme.breakpoints.up("md")]: { width: "50%" },
    [theme.breakpoints.up("lg")]: { width: "35%" },
  },
}));

const ProfileCard = styled(Box)(({ selected }) => ({
  border: selected ? "2px solid #3b82f6" : "1px solid #e5e7eb",
  borderRadius: "12px",
  padding: "16px",
  marginBottom: "12px",
  cursor: "pointer",
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  transition: "border 0.3s ease",
}));

const LeftContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

const UserInfo = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const Roles = styled(Box)({
  display: "flex",
  gap: "8px",
  fontSize: "12px",
  color: "#6b7280",
  marginTop: "4px",
});

const StatusChip = ({ label, color }) => (
  <Chip
    label={label}
    size="small"
    style={{
      backgroundColor: color,
      color: "#fff",
      fontWeight: 500,
    }}
  />
);

const SwitchProfile = ({
  switchProfilePop,
  setSwitchProfilePop,
  dependentList,
  setDeleteDependentPopUp,
  setSelectDependentId,
}) => {
  const dispatch = useDispatch();
  const { visitorData } = useSelector((state) => state.memberDetails);
  const [userList, setUserList] = useState(dependentList || []);
  const [selectedProfile, setSelectedProfile] = useState(
    visitorData?._id || visitorData?.ID
  );

  useEffect(() => {
    if (visitorData && Object.keys(visitorData).length) {
      setUserList((prev) => {
        const exists = prev.find(
          (item) =>
            (item?._id || item?.ID) === (visitorData?._id || visitorData?.ID)
        );
        return exists ? prev : [...prev, visitorData];
      });
    }
  }, [dependentList]);

  useEffect(() => {
    if (dependentList[dependentList?.length - 1]) {
      setUserList((prev) => {
        const exists = prev.find(
          (item) =>
            (item?._id || item?.ID) ===
              dependentList[dependentList?.length - 1]._id ||
            dependentList[dependentList?.length - 1].ID
        );

        return exists
          ? prev
          : [...prev, dependentList[dependentList?.length - 1]];
      });
    }
  }, [dependentList]);

  const handleProfileClick = (value) => {
    setSelectedProfile(value);
    const selectedUser = userList.find(
      (item) => (item.ID || item._id) === value
    );
    dispatch(
      setUserDetails({ userData: [selectedUser], dependentList: userList })
    );

    setSwitchProfilePop(false);
  };

  const getStatus = (user) => {
    if (user.status === "pending")
      return <StatusChip label="Pending" color="#f97316" />;
    if (user.status === "verified")
      return <StatusChip label="Verified" color="#22c55e" />;
    return null;
  };

  return (
    <Fragment>
      <StyledDialog
        open={switchProfilePop}
        onClose={() => setSwitchProfilePop(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogContent sx={{ backgroundColor: "#f9fafb", padding: "24px" }}>
          <Typography
            variant="h6"
            fontWeight={600}
            mb={2}
            sx={{ textAlign: "center", color: "#111827" }}
          >
            Switch Profile
          </Typography>
          {console.log(userList, "userList")}
          {userList?.map((profile, index) => {
            const name = `${profile.first_name || profile.firstName || ""} ${
              profile.last_name || profile.lastName || ""
            }`.trim();
            const email =
              profile.emailID || profile.email_id || "noemail@example.com";

            const isSelected = (profile.ID || profile._id) === selectedProfile;
            const isActive = isSelected;
            const value = profile.ID || profile._id;

            return (
              <ProfileCard key={index} selected={isSelected}>
                <LeftContent>
                  <Avatar>{name.charAt(0)}</Avatar>
                  <UserInfo onClick={() => handleProfileClick(value)}>
                    <Typography fontWeight={600}>
                      {name} {profile.star && "⭐"}
                      {isActive && (
                        <Chip
                          label="Active"
                          size="small"
                          style={{
                            backgroundColor: "#3b82f6",
                            color: "#fff",
                            marginLeft: "6px",
                            fontWeight: 500,
                          }}
                        />
                      )}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {email}
                    </Typography>
                    {/* <Roles>{roles.join(" · ")}</Roles> */}
                  </UserInfo>

                  <RiDeleteBin6Line
                    style={{
                      width: "20px",
                      height: "20px",
                      color: "#ff0000ff",
                    }}
                    onClick={() => {
                      setDeleteDependentPopUp(true);
                      setSelectDependentId(profile.ID || profile._id);
                    }}
                  />
                </LeftContent>

                {getStatus(profile)}
              </ProfileCard>
            );
          })}
        </DialogContent>
      </StyledDialog>
    </Fragment>
  );
};

export default SwitchProfile;
